import { render, staticRenderFns } from "./nonstandardEdit.vue?vue&type=template&id=ef18996c&scoped=true"
import script from "./nonstandardEdit.vue?vue&type=script&lang=js"
export * from "./nonstandardEdit.vue?vue&type=script&lang=js"
import style0 from "./nonstandardEdit.vue?vue&type=style&index=0&id=ef18996c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef18996c",
  null
  
)

export default component.exports